

import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { MsalProvider, useMsal } from '@azure/msal-react';
import { msalInstance } from './components/config/OIDCConfig';
import SigninWidget from './components/auth/SigninWidget'
import ManageUser from './components/pages/ManageUser'
import PBIReports from './components/reports/PowerBiReports';
import useAutoLogout from './components/auth/AutoLogout';


const ProtectedRoute = ({ element: Element, ...rest }) => {
  const { accounts } = useMsal();

  if (!accounts || accounts.length === 0) {
    // User is not authenticated, navigate to login
    return <Navigate to="/" />;
  }

  return <Route {...rest} element={<Element />} />;
};


const App = ({instance}) => {
  useAutoLogout(); // Automatically logs out after 5 minutes of inactivity

  return (
    <MsalProvider instance={msalInstance}>
        <Routes>
          <Route path="/" element={<SigninWidget />} />
          <Route path="/ManageUser" element={<ManageUser />} />
          <Route path="/reports/:ReportID/view" element={<PBIReports/>}/>

          {/* <Route path="/Home" element={<ProtectedRoute element={<Home />} />} />  */}

        </Routes>
    </MsalProvider>
  );
};

export default App;

